module.exports = __webpack_public_path__ + "static/media/api_logo_pwrdBy_strava_horiz_gray.02a52be4.svg";